<wiz-hgroup #mainGP wizValidationContainer height="100%" width="100%" style="padding: 0px" gap="0">

  <wiz-text-input
    #ti
    [visible]="isText"
    [ngClass]="forceCaps"
    [wizMaxChars]="50"
    ([wizValue])="textValue"
    wizValidator
    wizShowLabel="false"
    width="100%"
    height="100%"
    wizFocusMode="ROLLBACK"
  ></wiz-text-input>
  <wiz-numeric-input
    #ni
    [visible]="isNum"
    wizFocusMode="ROLLBACK"
    ([wizNumber])="numValue"
    [wizMaxChars]="20"
    wizValidator
    wizShowLabel="false"
    width="100%"
    height="100%"
    nbDecimal="0"
  ></wiz-numeric-input>
  <!-- la classe ag-custom-component-popup ajoutée au wiz-datefield permet à l'ag-grid d'interagir correctement avec le composant custom du datepicker -->
  <wiz-datefield
    #da
    [visible]="isDate"
    wizValidator
    wizShowLabel="false"
    width="100%"
    height="100%"
    wizFocusMode="ROLLBACK"
    wizExtraClassDatePicker="ag-custom-component-popup"
  ></wiz-datefield>
  <wiz-timefield #tf wizShowLabel="false"
    [visible]="isTime"
    width="100%"
    height="100%"
    wizValidator
    wizFocusMode="ROLLBACK"
    >
  </wiz-timefield>
</wiz-hgroup>
